import documentService from "services/documentService";
import routerHelper from "helpers/routerHelper";
import settingRepository from "repositories/settingRepository";
import { DispatchTemplateService } from "services/dispatch-template-service";
import { autoinject } from "aurelia-dependency-injection";

@autoinject()
export class MaterialOrderDocumentAdd {
    public dispatchId?: string;

    public readonly: boolean = false;
    public actions: any = {};
    public isCategorySelectionAllowed: boolean = false;
    private dispatchTemplateId: string | null = "";

    constructor(
        private readonly dispatchTemplateService: DispatchTemplateService
    ) {}

    public async activate(params: any): Promise<void> {
        const paramsQueryString = routerHelper.getQuerystring(params.q);
        this.readonly = !(paramsQueryString && paramsQueryString.readonly === "false");

        this.dispatchTemplateId = settingRepository.getDispatchTemplate();
        const dispatchTemplate = await this.dispatchTemplateService.GetDispatchTemplatesByCode(this.dispatchTemplateId!);

        this.isCategorySelectionAllowed = dispatchTemplate!.AllowCategorySelection;

        this.setupHeaderInfos(params.dispatchId);

        await this.setAction(params.orderId);
    }

    private setupHeaderInfos(dispatchId: string): void {
      this.dispatchId = dispatchId;
    }

    private async setAction(orderId: string): Promise<void> {
        this.actions = {
            save: documentService.addDocumentByPurchaseOrderId.bind(self, orderId, this.dispatchTemplateId)
            };
    }
}
